// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__14HsA","right":"Footer_right__3OLZH","buttons":"Footer_buttons__112Zt"};